module.exports = new __parcel__URL__("live-chat-button-icon.faf0df66.png").toString();